export const getSampleMacros = () => [
  {
    name: 'Minimal Presets',
    macro: {
      copied: {
        sedationLevel: 'Minimal',
        ivEnabled: false,
        airwayEnabled: false,
        calculateDrugWaste: true,
        dischargeScoreType: 'pads',
      },
      vitalTypes: { ecg: 'selected', fico2: 'ignored', fides: 'ignored' },
      localDrugs: [
        {
          id: '2117|1',
          name: 'Articaine',
          percent: 0.04,
          unit: 'mg',
          epi: 200,
          dose: '1',
          rxcui: '2117',
        },
        {
          id: '142440|2',
          name: 'Lidocaine',
          percent: 0.02,
          unit: 'ml',
          epi: 100,
          dose: '2',
          rxcui: '142440',
        },
        {
          id: '267396|0',
          name: 'Bupivacaine',
          percent: 0.005,
          unit: 'cartridges',
          epi: 200,
          rxcui: '267396',
        },
      ],
      oralSedatives: [
        { id: '10767', name: 'Triazolam', unit: 'mg', dose: '10', route: 'PO' },
      ],
    },
  },
  {
    name: 'Moderate Presets',
    macro: {
      copied: {
        sedationLevel: 'Moderate',
        ivEnabled: true,
        airwayEnabled: true,
        calculateDrugWaste: true,
        dischargeScoreType: 'pads',
      },
      vitalTypes: { ecg: 'selected', fico2: 'ignored', fides: 'ignored' },
      localDrugs: [
        {
          id: '2117|1',
          name: 'Articaine',
          percent: 0.04,
          unit: 'mg',
          epi: 200,
          dose: '1',
          rxcui: '2117',
        },
        {
          id: '142440|2',
          name: 'Lidocaine',
          percent: 0.02,
          unit: 'ml',
          epi: 100,
          dose: '2',
          rxcui: '142440',
        },
        {
          id: '267396|0',
          name: 'Bupivacaine',
          percent: 0.005,
          unit: 'cartridges',
          epi: 200,
          rxcui: '267396',
        },
      ],
      parenDrugs: [
        {
          id: '289',
          route: 'IV',
          name: 'Adenosine',
          draw: '20',
          dose: '10',
          unit: 'mg',
        },
        {
          id: '6960',
          route: 'IM',
          name: 'Midazolam',
          draw: '20',
          dose: '10',
          unit: 'mg',
        },
      ],
      oralSedatives: [
        { id: '2599', name: 'Clonidine', unit: 'mg', dose: '20', route: 'SL' },
      ],
    },
  },
  {
    name: 'Deep Presets',
    macro: {
      copied: {
        sedationLevel: 'Deep',
        ivEnabled: true,
        airwayEnabled: true,
        calculateDrugWaste: true,
        dischargeScoreType: 'pads',
      },
      vitalTypes: { ecg: 'selected', fico2: 'ignored', fides: 'ignored' },
      localDrugs: [
        {
          id: '2117|1',
          name: 'Articaine',
          percent: 0.04,
          unit: 'mg',
          epi: 200,
          dose: '1',
          rxcui: '2117',
        },
        {
          id: '142440|2',
          name: 'Lidocaine',
          percent: 0.02,
          unit: 'ml',
          epi: 100,
          dose: '2',
          rxcui: '142440',
        },
        {
          id: '267396|0',
          name: 'Bupivacaine',
          percent: 0.005,
          unit: 'cartridges',
          epi: 200,
          rxcui: '267396',
        },
      ],
      parenDrugs: [
        {
          id: '289',
          route: 'IV',
          name: 'Adenosine',
          draw: '30',
          dose: '15',
          unit: 'mg',
        },
        {
          id: '6960',
          route: 'IM',
          name: 'Midazolam',
          draw: '30',
          dose: '15',
          unit: 'mg',
        },
      ],
      oralSedatives: [
        { id: '10767', name: 'Triazolam', unit: 'mg', dose: '30', route: 'PO' },
        { id: '6130', name: 'Ketamine', unit: 'mg', dose: '30', route: 'SL' },
      ],
      infusionDrugs: [
        {
          id: '8782',
          name: 'Propofol',
          dose: '30',
          unit: 'mcg/kg/hr',
          bolusUnit: 'mcg',
        },
        {
          id: '480',
          name: 'Alfentanil',
          dose: '30',
          unit: 'mcg/min',
          bolusUnit: 'mcg',
        },
      ],
    },
  },
  {
    name: 'GA Presets',
    macro: {
      copied: {
        sedationLevel: 'GA',
        ivEnabled: true,
        airwayEnabled: true,
        calculateDrugWaste: true,
        dischargeScoreType: 'pads',
      },
      vitalTypes: { ecg: 'selected', fico2: 'ignored', fides: 'ignored' },
      localDrugs: [
        {
          id: '2117|1',
          name: 'Articaine',
          percent: 0.04,
          unit: 'mg',
          epi: 200,
          dose: '1',
          rxcui: '2117',
        },
        {
          id: '142440|2',
          name: 'Lidocaine',
          percent: 0.02,
          unit: 'ml',
          epi: 100,
          dose: '2',
          rxcui: '142440',
        },
        {
          id: '267396|0',
          name: 'Bupivacaine',
          percent: 0.005,
          unit: 'cartridges',
          epi: 200,
          rxcui: '267396',
        },
      ],
      parenDrugs: [
        {
          id: '289',
          route: 'IV',
          name: 'Adenosine',
          draw: '40',
          dose: '20',
          unit: 'mg',
        },
        {
          id: '6960',
          route: 'IM',
          name: 'Midazolam',
          draw: '40',
          dose: '20',
          unit: 'mg',
        },
      ],
      oralSedatives: [
        { id: '10767', name: 'Triazolam', unit: 'mg', dose: '40', route: 'PO' },
        { id: '6130', name: 'Ketamine', unit: 'mg', dose: '40', route: 'SL' },
      ],
      infusionDrugs: [
        {
          id: '8782',
          name: 'Propofol',
          dose: '40',
          unit: 'mcg/kg/hr',
          bolusUnit: 'mcg',
        },
        {
          id: '480',
          name: 'Alfentanil',
          dose: '40',
          unit: 'mcg/min',
          bolusUnit: 'mcg',
        },
      ],
    },
  },
]
